import { motion } from 'framer-motion';

interface SectionTransitionProps {
  children: React.ReactNode;
  direction?: 'up' | 'down';
}

export function SectionTransition({ children, direction = 'up' }: SectionTransitionProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: direction === 'up' ? 20 : -20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
} 